import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { ColorContrastControls } from '../shared/color-contrast-controls';
export const ColorContrastElementRegularContent = _ref => {
  let {
    locale,
    minimalRatio,
    elementIndex,
    status,
    failedElement,
    onChangeElementsColor,
    onClickCancel,
    onClickApply,
    showLoader,
    pageId
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, t('accessibility-wizard.rules-list.color-contrast.element.content', {
    minimalRatio: new Intl.NumberFormat(locale).format(minimalRatio)
  })), /*#__PURE__*/React.createElement(ColorContrastControls, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    isGeneric: false,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onChangeElementsColor: onChangeElementsColor,
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  }));
};
//# sourceMappingURL=color-contrast-element-regular-content.js.map